import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { Product } from '../domain/dtos/product'
import { ToggleProductVisibilityInput } from '../domain/dtos/toggle-product-visibility-input'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'

export class ToggleProductVisibility {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(input: ToggleProductVisibilityInput): Promise<Product> {
    const response = await this.httpClient.request({
      method: HttpMethod.PATCH,
      url: `${Envs.BFF_PRODUCT_URL}/products/${input.productId}/visibility`,
    })

    if (response.statusCode === HttpStatusCode.OK || response.statusCode === HttpStatusCode.CREATED) {
      return response.data
    }

    throw new GeneralError()
  }
}
